module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_arrow_right_disabled.5680e0fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_arrow_right_disabled.svg
// module id = 983
// module chunks = 0